import { render, staticRenderFns } from "./btnCallLink.vue?vue&type=template&id=9546a114&scoped=true"
import script from "./btnCallLink.vue?vue&type=script&lang=js"
export * from "./btnCallLink.vue?vue&type=script&lang=js"
import style0 from "./btnCallLink.vue?vue&type=style&index=0&id=9546a114&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9546a114",
  null
  
)

export default component.exports